import React from 'react';
import Opiniones from '../components/Opiniones';

function Testimonials() {
    return <Opiniones />;
}

export default Testimonials;
